import React from "react";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import { useDaylightFactorColorBar } from "../CustomHooks";

const ColorBarDaylightFactor = () => {
  const { isVisible, subcategory } = useDaylightFactorColorBar();

  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.DAYLIGHT}
      category="Daylight Factor"
      subcategory={subcategory}
      unit="%"
      dataMin={0}
      dataMax={100}
      isVisible={isVisible}
    />
  );
};

export default ColorBarDaylightFactor;
